import { call } from "redux-saga/effects";
import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import { ReducerMethods } from "../../store/reducer.methods";
import { API_DOMENS, BASE_API_PAGE_ENUMS } from "../../../constants/apis.constants.js";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import { CallToast } from "../../../Components/PriceCalculator/modals/CustomToast";
import type { GetToolInfoDto, GetToolInfoResponse } from "./dto/get-tool-info.dto";
import type { GetPracticeTypesDto, GetPracticeTypesResponse } from "./dto/get-practice-types.dto";

export const ToolInfoEffectActions = {
  getToolInfo: `${Entities.ToolInfo}_getToolInfo`,
  getPracticeTypes: `${Entities.ToolInfo}_getPracticeTypes`,
};

const initSchema: InitSchemaReducer = {
  definitions: {},
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.ToolInfo,
  initSchema,
  aliasName: DIContainerKeys.ToolInfoService,
})
export class ToolInfoService extends HttpService {
  @loader(Loaders.GetToolInfoLoader)
  @action(DIContainerKeys.ToolInfoService)
  public *getToolInfo(dto: GetToolInfoDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetToolInfoLoader, true);
    const response: GetToolInfoResponse = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetToolInfo),
        params: {
          optionEnum1: dto.toolId,
          optionEnum2: dto.clientId,
        },
        domain: API_DOMENS.CC_API,
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetToolInfoLoader, false);
      return;
    }
    const { mr, ...payload } = response;
    const entityId = dto.clientId ? `${dto.clientId}-${dto.toolId}` : dto.toolId;
    const currentState = yield this.di.reduxStore.state()?.[Entities.ToolInfo]?.[entityId] || {};
    yield this.setEntityStateById(Entities.ToolInfo, entityId, {
      ...currentState,
      ...payload,
    });
    yield this.setLoaderState(Loaders.GetToolInfoLoader, false);
  }

  @loader(Loaders.GetPracticeTypesLoader)
  @action(DIContainerKeys.ToolInfoService)
  public *getPracticeTypes(dto: GetPracticeTypesDto): Generator<any, void, any> {
    yield this.setLoaderState(Loaders.GetPracticeTypesLoader, true);
    const response: GetPracticeTypesResponse = yield call(
      this.get,
      {
        url: this.pageEnum(BASE_API_PAGE_ENUMS.GetPracticeTypes),
        params: {
          optionEnum1: dto.toolId,
        },
        domain: API_DOMENS.CC_API,
      },
      ReducerMethods.UPDATE
    );
    if (!response?.mr?.Success) {
      CallToast("Something went wrong", false, false, "v2style");
      yield this.setLoaderState(Loaders.GetPracticeTypesLoader, false);
      return;
    }
    const { mr, ...payload } = response;
    const entityId = dto.clientId ? `${dto.clientId}-${dto.toolId}` : dto.toolId;
    const currentState = yield this.di.reduxStore.state()?.[Entities.ToolInfo]?.[entityId] || {};
    yield this.setEntityStateById(Entities.ToolInfo, entityId, {
      ...currentState,
      practiceTypes: payload?.TechnologyPracticeDetail_List,
    });
    yield this.setLoaderState(Loaders.GetPracticeTypesLoader, false);
  }
}

